import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import centralized_service from '../../resource/middleware_mobile/centralized_service.png';


const CentralizedServiceMobile = () => {
    return (
        <ProductItemView
            title="Servicio centralizado"
            items={["Consumo de recursos optimizado", "Windows / Linux compatible", "Agregar una conexión a Middleware es un proceso corto, simple"]}
            image={centralized_service}
            centered
            withGap />
    );
};

export default CentralizedServiceMobile;